module.exports = __webpack_public_path__ + "static/img/twjd-sdo25.49b780a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdo25.png
// module id = 864
// module chunks = 0